import { createSelector } from 'reselect';

import { AppState } from '../../types';

export const selectVideoList = (state: AppState) => state.videos.list;

export const selectVideo = (state: AppState) => state.videos.selected;

export const isVideoPersistent = createSelector(
  selectVideo,
  (state) => Boolean(state.data?.id),
);

export const selectVideoTitle = createSelector(
  selectVideo,
  (state) => state.data?.title,
);
